import { render, staticRenderFns } from "./RecruiterView.vue?vue&type=template&id=00dc4033&scoped=true&"
import script from "./RecruiterView.vue?vue&type=script&lang=js&"
export * from "./RecruiterView.vue?vue&type=script&lang=js&"
import style0 from "./RecruiterView.vue?vue&type=style&index=0&id=00dc4033&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00dc4033",
  null
  
)

export default component.exports